import ContactMain from "./ContactMain";


export default function Main ({data, price}) {
    const flightDataHead = ["שם", "מס' טיסה", "תאריך", "יום", "מיקום", "יעד", "המראה", "נחיתה", "מזוודה", "טרולי"];
    const carsDataHead = ["שם", "תאריך", "יום", "שעה", "מיקום", "יעד", 'סה"כ נסיעה', "מסלול"];

    const dataHover = {
        extraFlight: "במקרה של טיסה צד אחד ולא הלוך חזור ",
        extraCarA: "במקרה שלוקחים רק נ\"פ בלי טיסות מתווסף 20$",
        extraChange: "תוספת על שינוי טיסה",
        extraCancel: "תוספת על ביטול טיסה"
    }

    const names = {
        extraChange : "תוספת על שינוי טיסה",
        extraCancel: "תוספת על ביטול טיסה"
    }

    return (<> {

        Object.entries(data).map(([key, value], keyKey) => (
            <ContactMain
            data={value || names[key]}
            name={key.startsWith('extra') ? "תוספת" : `${key.startsWith('f') ? "טיסה" : 'נ"פ'} ${key.endsWith('a') ? "הלוך" : "חזור"}`}
            price={price[key]}
            flight_or_car={key.startsWith('f')}
            dataHover={key.startsWith('f') ? flightDataHead : key.startsWith('c') ? carsDataHead : dataHover[key]}
            />
        ))
    } 
    
    </>)
}